import { ReactElement } from "react";
import styles from "./styles.module.css";
import { Equipamento } from "../../../model/PlanoDeTrabalho/AquisicaoDeEquipamentos";

type Props = {
  titulo: string;
  modalidade: string;
  area: string;
  inicio: Date;
  fim: Date;
  children: ReactElement | ReactElement[];
};

const RowPlanoDeTrabalho = ({
  titulo,
  modalidade,
  area,
  inicio,
  fim,
  children,
}: Props) => {
  return (
    <tr className={styles.row}>
      <td>{titulo}</td>
      <td className={styles.sexto}>{modalidade}</td>
      <td className={styles.sexto}>{area}</td>
      <td className={styles.sexto}>
        <strong>inicio:</strong> {inicio.toLocaleDateString()} <br />
        <strong>fim:</strong> {fim.toLocaleDateString()}
      </td>
      <td className={styles.btncoll}>{children}</td>
    </tr>
  );
};
export default RowPlanoDeTrabalho;
